// extracted by mini-css-extract-plugin
export default {"bold-text":"NavigationBar_bold-text__QQ6PW","nav-link":"NavigationBar_nav-link__kHnKh"};